import axios from "axios";

const defaultOptions = {
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    "System-Key": process.env.REACT_APP_SYSTEM_KEY,
  },
};

const instance = axios.create(defaultOptions);


instance.interceptors.request.use(function (config) {
  const systemKey = process.env.REACT_APP_SYSTEM_KEY; 
  config.headers["System-Key"] = "Green-heap-gold"; 

  return config;
});

instance.interceptors.response.use(
  (response) => {
    if (
      response.status === 401 ||
      response.status === 403 ||
      response.data?.status === 403
    ) {
      
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;


